/**
 * @file:
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/7/10      1.0     First version
 *
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React from "react";

export default class DopIndex  extends React.Component {
    render(){
        return (<div className="black89 pt_40 text-center">
            <img src={"https://oss.essaone.com/ba0bc74b-252d-4cba-82b1-f887c57f93fb.jpg"} />
        </div>);
    }
}